import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { useEffect, useState } from 'react'

import { useAppStore } from '../../shared/store/store'
import { ModelControls } from '../utils/ModelControls'
import { isMobileOrTablet } from '../../../../trillion-common/src/utils/device-utils'

export function useControls(camera: THREE.Camera, domElement?: HTMLElement) {
  const rotateObject = useAppStore((state) => state.rotateObject)
  const rotateSpeed = useAppStore((state) => state.rotateSpeed)
  const isGUIEnabled = useAppStore((state) => state.isGUIEnabled) // useAppStore.getState().isGUIEnabled
  const autoRotateSpeed = useAppStore((state) => state.autoRotateSpeed) // useAppStore.getState().autoRotateSpeed

  const [controls, setControls] = useState<ModelControls | OrbitControls | undefined>()

  useEffect(() => {
    if (!camera || !domElement) return

    const _controls = new (rotateObject ? ModelControls : OrbitControls)(camera, domElement)
    _controls.enableDamping = true
    _controls.dampingFactor = 0.06
    _controls.rotateSpeed = (rotateSpeed ?? 1.2) * (isMobileOrTablet() && rotateObject ? 4.2 : 1)
    _controls.zoomSpeed = 1
    _controls.update()

    setControls(_controls)
  }, [camera, domElement, rotateObject])

  useEffect(() => {
    if (!controls) return
    controls.enablePan = isGUIEnabled

    if (autoRotateSpeed) {
      controls.autoRotate = true
      controls.autoRotateSpeed = autoRotateSpeed

      const azimuthalAngle = controls.getAzimuthalAngle()
      if (
        azimuthalAngle >= controls.maxAzimuthAngle ||
        azimuthalAngle <= controls.minAzimuthAngle
      ) {
        controls.autoRotateSpeed *= -1
      }
    } else {
      controls.autoRotate = false
    }

    controls.update()
  }, [controls, isGUIEnabled, autoRotateSpeed])

  return controls
}
